const moment = require('moment');
const { parsePhoneNumberFromString } = require('libphonenumber-js/max');

const ColorContrastChecker = require('color-contrast-checker');

const colorChecker = new ColorContrastChecker();

const getContrastColor = (color) => {
  console.log('color', color);
  const whiteTextColor = '#ffffff';
  const darkGreyTextColor = '#313638';
  const isContrastWhite = colorChecker.isLevelAA(color, whiteTextColor);
  if (isContrastWhite) {
    console.log('white');
    return whiteTextColor;
  }
  console.log('black');
  return darkGreyTextColor;
};

/**
 * Parse google address to our address format
 * @param {Object} addressData: vue2-google-maps addressData
 * @param {Object} place: google api original place result
 */
const parseGoogleAddress = (addressData, place) => {
  const address = {
    formatted: place.formatted_address,
    // lat: addressData.latitude,
    // lng: addressData.longitude,
    addressLine1: (addressData.street_number ? (`${addressData.street_number} `) : '') + addressData.route,
    addressLine2: '',
    suburb: addressData.locality,
    state: addressData.administrative_area_level_1,
    postcode: addressData.postal_code,
    country: addressData.country,
    isManual: false
  };
  return address;
};
// test checking

const checkValidMobile = (rule, value, callback, isUnder18 = false, countryCode = 'AU') => {
  console.log('under18', isUnder18);

  if (!value || value === '') {
    if (rule.field === 'profile.meta.parentOrGuardian1.mobile') {
      if (isUnder18) return callback(new Error('Mobile is required'));
      return callback();
    }
    return callback(new Error('Mobile is required'));
  }
  console.log('checkValidMobile', value);
  // eslint-disable-next-line no-param-reassign
  value = value.replace(/\s/g, '');
  const phoneNumber = parsePhoneNumberFromString(value, countryCode);
  const test = !!(((phoneNumber && phoneNumber.isValid() && (phoneNumber.getType() === 'MOBILE' || phoneNumber.getType() === 'FIXED_LINE_OR_MOBILE'))));
  if (test) return callback();
  return callback(new Error('Invalid mobile'));
};

/**
 * Calculate age
 * @param {string} dob: birthdate
 * @param {string} endOfYear: YYYY-MM-DD
 * @param {string} [format]: birthdate format, default: YYYY-MM-DD
 */
const calculateMemberAge = (dob, endOfYear, format = 'YYYY-MM-DD') => {
  const birth = moment(dob, format);
  if (endOfYear) {
    const current = moment(endOfYear, 'YYYY-MM-DD');
    return current.diff(birth, 'years');
  }
  return moment().diff(birth, 'years');
};

/**
 * convert url into hyperlink markup
 */
function urlify(text) {
  // eslint-disable-next-line no-var
  var urlRegex = /https?:\/\/[^\s]+/gi;
  return text.replace(urlRegex, (url, offset, string) => {
    // Check if the URL is inside an existing <a> tag
    const searchString = 'href="';
    const before = string.slice(offset - searchString.length, offset);
    if (before === searchString) {
      return url;
    }

    return `<a href="${url}" target="_blank">${url}</a>`;
  });
}

module.exports = {
  parseGoogleAddress,
  calculateMemberAge,
  urlify,
  checkValidMobile,
  getContrastColor
};
